import { ViewProps } from 'react-native';
import styled from 'styled-components/native';

export const SquareMeterInput = styled.TextInput<ViewPropsTypes>`
  width: 100px;
  height: 55px;
  border-width: 1px;
  border-radius: 7px;
  border-color: ${({ borderColor }) => borderColor};
  padding-horizontal: 10px;
  text-align: center;
  font-size: 17px;
`;

export const SquareMeterContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const SuperscriptContainer = styled.View`
  flex-direction: row;
  align-items: flex-start;
  padding-left: 10px;
`;

export const Superscript = styled.Text`
  text-align-vertical: top;
  font-size: 15px;
  line-height: 18px;
`;

export const Regular = styled.Text`
  text-align-vertical: bottom;
  font-size: 20px;
  line-height: 30px;
`;

/** Type definitions */
interface ViewPropsTypes extends ViewProps {
  /** border color */
  borderColor: string;
}
